import React, {useRef, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import styles from './SiteHeader.module.css';
import LogoMark from './Logo';
import Button from './Button';
import MobileMenu from './MobileMenu';
import {MenuIcon, CloseIcon} from '../icons/Icons';
import {CREATE_PAGE_ROUTE, HOW_TO_ROUTE, CONTACT_ROUTE, LOGIN_ROUTE} from '../routes';

const NAV_LINKS = [
    {to: HOW_TO_ROUTE, label: 'How to'},
    {to: CONTACT_ROUTE, label: 'Contact'},
];

const isActive = (pathname, to) => pathname.toLowerCase() === to.toLowerCase();

const SiteHeader = () => {
    const {pathname} = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuButtonRef = useRef(null);

    const closeMenu = () => {
        setMenuOpen(false);
        if (menuButtonRef.current) menuButtonRef.current.focus();
    };

    return (
        <header className={styles.header}>
            <div className={styles.inner}>
                <Link to="/" className={styles.brand} aria-label="Ovalview home">
                    <LogoMark/>
                    <span className={styles.wordmark}>Ovalview</span>
                </Link>

                <nav aria-label="Main" className={styles.nav}>
                    <Link
                        to={CREATE_PAGE_ROUTE}
                        className={styles.navLink}
                    >
                        Create page
                    </Link>
                    {NAV_LINKS.map(({to, label}) => (
                        <Link
                            key={to}
                            to={to}
                            className={`${styles.navLink} ${isActive(pathname, to) ? styles.navLinkActive : ''}`}
                            aria-current={isActive(pathname, to) ? 'page' : undefined}
                        >
                            {label}
                        </Link>
                    ))}
                </nav>

                <div className={styles.actions}>
                    <Link to={LOGIN_ROUTE} className={styles.loginLink}>Log in</Link>
                    <Button to={LOGIN_ROUTE} variant="primary" size="nav">Sign up free</Button>
                </div>

                <div className={styles.mobileActions}>
                    <Button to={LOGIN_ROUTE} variant="primary" size="nav" className={styles.mobileSignup}>
                        Sign up free
                    </Button>
                    <button
                        ref={menuButtonRef}
                        type="button"
                        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                        aria-expanded={menuOpen}
                        aria-controls="mobile-menu"
                        className={styles.menuButton}
                        onClick={() => setMenuOpen((open) => !open)}
                    >
                        {menuOpen ? <CloseIcon/> : <MenuIcon/>}
                    </button>
                </div>
            </div>

            <MobileMenu open={menuOpen} onClose={closeMenu} currentPath={pathname}/>
        </header>
    );
};

export default SiteHeader;
